import Helpers from "./helpers";

export enum CountdownType {
	Offer,
	Product
}

export default class Countdown {

	private currentElement: HTMLElement;
	private startDateTime: string;
	private productShowHours: string; // Drench B test
	private endDateTime: number;
	private templatePrefix: string;
	private countdownType: CountdownType;
	private desktopMode: boolean;
	private timer: any;

	constructor(currentElement: HTMLElement, templatePrefix: string, countdownType: CountdownType) {

		this.currentElement = currentElement;
		this.startDateTime = currentElement.getAttribute('data-countdown-cutoff') || currentElement.getAttribute('data-cutoff');
		this.productShowHours = currentElement.getAttribute('data-cutoff-product-show-hours'); // Drench B test
		this.templatePrefix = templatePrefix;
		this.countdownType = countdownType;
		this.desktopMode = currentElement.getAttribute('data-countdown') === 'desktop';
		this.start();

	}

	private start() {

		let dateEnd = new Date(this.startDateTime).getTime();
		this.endDateTime = dateEnd;

		if (isNaN(dateEnd)) {
			return;
		}

		this.calculate();
		const tick = () => {
			const now = Date.now();
			const timeRemaining = this.endDateTime - now;

			if (timeRemaining >= 0) {
				this.calculate();
				const nextTick = 1000 - (now % 1000); // Calculate the time until the next second
				this.timer = setTimeout(tick, nextTick);
			} else {
				if (this.countdownType === CountdownType.Offer) {
					this.removeOfferBanners();
				}
				clearTimeout(this.timer);
			}
		};

		tick();
		this.currentElement.setAttribute('data-countdown', 'initialised');
		this.currentElement.classList.add('has-initialised');


	}

	private calculate() {
		const dateStart = new Date();
		const timeRemaining = (this.endDateTime - dateStart.getTime());

		if (timeRemaining >= 0) {
			const formattedDate = this.formatDate(timeRemaining);
			this.currentElement.innerHTML = formattedDate;
		} else {
			if (this.countdownType === CountdownType.Offer) {
				this.removeOfferBanners();
			}
			clearInterval(this.timer);
			return;
		}
	}

	private formatDate(timeRemaining: number) {

		const secondsLeft = Math.ceil(timeRemaining / 1e3);

		const weeks = Math.floor(secondsLeft / 60 / 60 / 24 / 7);
		const days = Math.floor(secondsLeft / 60 / 60 / 24) % 7;
		const hours = Math.floor(secondsLeft/ 60 / 60) % 24;
		const minutes = Math.floor(secondsLeft / 60) % 60;
		const seconds = Math.floor(secondsLeft % 60);

		if (this.countdownType === CountdownType.Offer) {
			return this.buildOfferHTML(weeks, days, hours, minutes, seconds);
		}

		if (this.countdownType === CountdownType.Product) {
			return this.buildProductHTML(hours, minutes);
		}
		
	}

	private buildOfferHTML(weeks: number, days: number, hours: number, minutes: number, seconds: number) {

		let output = '';

		if (weeks) {
			output += this.formatDateString(weeks, this.desktopMode ? this.pluralise('week', weeks) : 'w', false, this.desktopMode);
		}

		if (days) {
			output += this.formatDateString(days, this.desktopMode ? this.pluralise('day', days) : 'd', false, this.desktopMode);
		}

		if (hours) {
			output += this.formatDateString(hours, this.desktopMode ? this.pluralise('hour', hours) : 'h', false, this.desktopMode);
		}

		if (minutes) {
			output += this.formatDateString(minutes, this.desktopMode ? this.pluralise('minute', minutes) : 'm', false, this.desktopMode);
		}

		if (seconds || minutes) {
			output += this.formatDateString(seconds, this.desktopMode ? this.pluralise('second', seconds) : 's', false, this.desktopMode);
		}

		return output; 
	}

	private buildProductHTML(hours: number, minutes: number) {
		let output = '';
		if (this.productShowHours && hours) {
			output += this.formatDateString(hours, this.pluralise('hour', hours), false);
			output += " and ";
		}
		output += this.formatDateString(minutes, this.pluralise('minute', minutes), false);
		return output;
	}

	private formatDateString(number: number, text: string, padNumber: boolean, addSpaceBeforeText = true) {
		return `<span>${this.templatePrefix} ${(padNumber ? this.pad(number, 2) : number)}</span>${addSpaceBeforeText ? " " : ""}${text}`;
	}

	private pluralise(text: string, number: number) {
		return `${text}${number === 1 ? "" : "s"}`
	}

	private pad(number: number, size: number) {
		let output = number + "";
		while (output.length < size) output = "0" + output;
		return output;
	}

	private removeOfferBanners() {
		const bannerContainer = this.currentElement.closest('.lOffer');
		if (bannerContainer) {
			Helpers.removeElement(bannerContainer);
		}
		const elementsToRemove = document.querySelectorAll('.js-remove-after-countdown');
		elementsToRemove.forEach((element) => {
			Helpers.removeElement(element);
		});
		const topOfferBanners = document.querySelectorAll('.js-top-offer-banner');
		topOfferBanners.forEach((element: HTMLElement) => {
			element.style.backgroundColor = '';
		});
	}

}

